import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/billing_rule_timers',
  component: Management,
  redirect: '/billing_rule_timers/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/billing_rule_timers/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listBillingRuleTimers
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/billing_rule_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTimers,
            tabName: 'all'
          }
        },
        {
          path: 'active',
          component: () => import('@/views/billing_rule_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTimers,
            tabName: 'active'
          }
        },
        {
          path: 'inactive',
          component: () => import('@/views/billing_rule_timers/ListTable'),
          meta: {
            auth: Auth.listBillingRuleTimers,
            tabName: 'inactive'
          }
        }
      ]
    },

    // 新增
    {
      path: 'batch_new',
      component: () => import('@/views/billing_rule_timers/BatchNew'),
      meta: {
        auth: Auth.createBillingRuleTimer
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/billing_rule_timers/Edit'),
      meta: {
        auth: Auth.updateBillingRuleTimer
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/billing_rule_timers/DetailLayout'),
      meta: {
        auth: Auth.showBillingRuleTimer
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/billing_rule_timers/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showBillingRuleTimer
          }
        }
      ]
    }
  ]
}
